
import Crown1 from "../../../assets/outline/Crown1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Crown1Icon({ className, dataTestid = "Crown1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Crown1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
